<div class="wrapper" style="width: 100%">
  <div class="d-flex justify-content-center align-self-center" >
    <div class="alert-success alert alert-dismissible d-flex justify-content-center" style="width: 100%">
      We are setting up your account. Please wait.
    </div>
  </div>
</div>
